module.exports = __webpack_public_path__ + "img/mark.3894d54d.svg";